import { createFileRoute } from "@tanstack/react-router"
import { PreferencesPage } from "@/features/account/preferences-page"
export const Route = createFileRoute("/_authenticated/account/appearance")({ component: PreferencesPage })
